<div
  class="ui-titlebar"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <div class="ui-titletext">
    Üzləşmə
    <span *ngIf="transactionNo" class="transactionNo"
      ><span class="pcOnly" style="margin-right: -5px">Qaimə</span
      >{{ transactionNo }}</span
    >
  </div>
  <div class="ui-titlecontrols" *ngIf="readOnly || editMode">
    <button 
      class="ui-btn operations" 
      [cdkMenuTriggerFor]="context_menu"
    >
      <i
        class="material-symbols-outlined"
        style="color: white; font-weight: 500"
        >more_horiz</i
      >
    </button>
  </div>
  <div class="ui-titlecontrols">
    <button class="ui-btn close" (click)="dialogRef.close()">
      <svg viewBox="0 0 10 10">
        <polygon
          points="10.2,0.7 9.5,0 5.1,4.4 0.7,0 0,0.7 4.4,5.1 0,9.5 0.7,10.2 5.1,5.8 9.5,10.2 10.2,9.5 5.8,5.1"
        />
      </svg>
    </button>
  </div>
</div>

<ng-template #context_menu>
  <div class="context-menu filterSettings" cdkMenu>
    <button
      (click)="readOnly = false; editMode = true"
      [disabled]="!readOnly"
      class="btn btn-outline-primary btnDelete padding-block-5 w-100 d-flex"
      style="
        box-shadow: unset;
        border-radius: 0px;
        border-bottom: 1px solid #ececec;
      "
      cdkMenuItem
    >
      <span class="material-symbols-outlined"> edit </span>
      <span class="w-100">Düzəliş et</span>
    </button>
    <button
      class="btn btn-outline-primary btnDelete padding-block-5 w-100 d-flex"
      (click)="deleteEntry()"
      style="box-shadow: unset; border-radius: 0px"
      cdkMenuItem
    >
      <span class="material-symbols-outlined"> delete </span>
      <span class="w-100">Sil</span>
    </button>
  </div>
</ng-template>

<div [cdkContextMenuTriggerFor]="context_menu">
  <div class="container-fluid">
    <div class="row px-3 py-3" style="background-color: #f6f6f6">
      <div class="col-md-6 col-sm-12">
        <div class="input-group">
          <div class="input-group-text">
            <i class="material-icons">inventory</i>
          </div>
          <ng-select
            [items]="_dataService.stockGroups()"
            bindLabel="name"
            bindValue="id"
            loadingText="Yüklənir .."
            notFoundText="Tapılmadı"
            [(ngModel)]="selectedStockGroupId"
            name="stockGroupId"
            class="form-control"
            placeholder="Anbar seçin"
            [disabled]="readOnly"
          >
          </ng-select>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 mt-smm-5">
        <div class="input-group">
          <div
            class="input-group-text"
            style="
              padding: 0px;
              width: 49px;
              height: 38px;
              display: flex;
              justify-content: center;
            "
          >
            <mat-datepicker-toggle [for]="myDatepicker">
              <mat-icon
                style="color: #0f4c7d; line-height: 21px"
                matDatepickerToggleIcon
                >calendar_month</mat-icon
              >
            </mat-datepicker-toggle>
          </div>
          <input
            #dateInput
            [(ngModel)]="date.value"
            [matDatepicker]="myDatepicker"
            class="form-control"
            tabindex="-1"
            style="
              border-top-right-radius: 6px;
              border-bottom-right-radius: 6px;
            "
            name="date"
            placeholder="{{
              _dataService.endDate.value
                ? _dataService.endDate.value.format('DD/MM/YYYY') ?? ''
                : _dataService.startDate.value.format('DD/MM/YYYY') ?? ''
            }}"
            (click)="dateInput.value = ''"
            (dateChange)="date.setValue($event.value)"
            (ngModelChange)="_dataService.formatDateValue(dateInput, date)"
            [disabled]="readOnly"
          />
          <mat-datepicker #myDatepicker [disabled]="readOnly"></mat-datepicker>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-content>
    <form #reconForm="ngForm" (keydown.enter)="$event.preventDefault()">
      <div class="container" style="overflow-x: hidden">
        <div
          class="row pb-3 pt-2 px-3"
          *ngFor="let item of materialsToReconcile; let i = index"
          style="border-bottom: 1px solid #eee"
        >
          <!-- Material Select -->
          <div class="col-md-4 col-sm-12 mb-2">
            <label class="form-label small text-muted" *ngIf="i === 0">Material</label>
            <div class="input-group">
              <div class="input-group-text fw-500">
                <mat-icon>sell</mat-icon>
              </div>
              <ng-select
                #input
                [items]="_dataService.materials()"
                bindLabel="name"
                bindValue="id"
                appendTo="body"
                loadingText="Yüklənir .."
                notFoundText="Tapılmadı"
                [(ngModel)]="item.materialId"
                name="materialId{{ i }}"
                class="form-control"
                [searchFn]="_dataService.customSearchFn"
                placeholder="Material seçin"
                (change)="onMaterialSelect(item, i)"
                [disabled]="readOnly"
                required
              >
              </ng-select>
            </div>
          </div>

          <!-- Expected (Current Stock) -->
          <div class="col-md-2 col-sm-6 mb-2">
            <label class="form-label small text-muted" *ngIf="i === 0">Gözlənilən</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                [(ngModel)]="item.expected"
                name="expected{{ i }}"
                readonly
                style="background-color: #f8f9fa"
              />
            </div>
          </div>

          <!-- Actual (User Input) -->
          <div class="col-md-2 col-sm-6 mb-2">
            <label class="form-label small text-muted" *ngIf="i === 0">Faktiki</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                [(ngModel)]="item.actual"
                (ngModelChange)="calculateDifference(item)"
                (focus)="item.actual === 0 ? item.actual = null : null"
                name="actual{{ i }}"
                [disabled]="readOnly"
                required
                autocomplete="off"
              />
            </div>
          </div>

          <!-- Difference -->
          <div class="col-md-2 col-sm-6 mb-2">
            <label class="form-label small text-muted" *ngIf="i === 0">Fərq</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                [ngModel]="item.difference"
                name="difference{{ i }}"
                readonly
                [ngClass]="{
                  'text-success': item.difference > 0,
                  'text-danger': item.difference < 0
                }"
                style="font-weight: 500"
              />
            </div>
          </div>

          <!-- Remove Button -->
          <div class="col-md-2 col-sm-6 mb-2 d-flex align-items-end">
            <button
              type="button"
              class="btn btn-outline-danger w-100"
              (click)="removeMaterialRow(i)"
              [disabled]="readOnly"
              *ngIf="materialsToReconcile.length > 1 || item.materialId"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          
          <!-- Notes (Optional, collapsible or inline) -->
          <div class="col-12 mt-1" *ngIf="item.materialId">
             <input 
               type="text" 
               class="form-control form-control-sm" 
               placeholder="Qeyd..." 
               [(ngModel)]="item.notes" 
               name="notes{{i}}"
               [disabled]="readOnly"
             >
          </div>
        </div>

        <!-- Add Row Button -->
        <div class="row px-3 pt-3" *ngIf="!readOnly">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-outline-secondary w-100 dashed-border"
              (click)="addMaterialRow()"
            >
              <mat-icon>add</mat-icon> Yeni sətir
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
</div>

<div
  class="d-grid"
  style="
    background-color: #f6f6f6;
    border-top: 1px solid #ececec;
    padding: 0.75rem 1.25rem;
  "
  *ngIf="!readOnly"
>
  <button
    #btnSave
    class="btn btn-outline-primary btnDelete w-100 d-flex justify-content-center align-items-center padding-block-5"
    (click)="saveReconciliation($event)"
    [disabled]="!reconForm.valid || dataLoading || !selectedStockGroupId"
  >
    <span style="font-size: 1.1rem">{{ editMode ? "Yenilə" : "Saxla" }}</span>
    <div *ngIf="dataLoading" class="lds-dual-ring"></div>
  </button>
</div>
